






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SelectSingleMonth from '@/shared/date-picker/single-month/select-single-month.component.vue';
import moment from 'moment';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    SelectSingleMonth,
    MainButton,
  },
})
export default class ContractBillingDailyModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) showModal!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) isContractItem!: boolean;

  competence: string = '';

  created() {
    this.competence = moment().format('YYYY-MM');
  }

  formatCompetence(competence: string): string {
    return moment(competence).format('MM/YYYY');
  }

  get alertMessage(): string {
    if (this.isContractItem) {
      return 'Se o faturamento do item do contrato for '
        + 'realizado fora da data de aniversário do contrato, os dados de consumo '
        + 'podem ainda não ter sido apurados pela unidade. Verifique se todas as '
        + 'informações estão atualizadas antes de prosseguir.'
    }
    return `Todos os contratos que já fizeram aniversário dentro da competência ${this.formatCompetence(this.competence)} serão faturados até a data de hoje.`;
  }

  cancel() {
    this.$emit('cancel');
  }

  execute() {
    this.$emit('execute', this.competence);
  }
}
